import { render, staticRenderFns } from "./RegisterBoxed.vue?vue&type=template&id=ee69d482&"
import script from "./RegisterBoxed.vue?vue&type=script&lang=js&"
export * from "./RegisterBoxed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports